export default __webpack_public_path__ + "static/blockchain-8e238681fe1adafa1aa08c7c88de592d.webp";